//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdeInstitutPredpokladPlan.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Institucion�ln� p�edpoklady pro pl�ny </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-14                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvvtip) GID:(Web.Dia.Ts) V1:(ixs_pla,ixs_tip,priz_pov,priz_pov_ixb,aktivita,dat_zmena,zmenu_prov,priz_nevyzad) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdeInstitutPredpokladPlan
    export function DetailAdeInstitutPredpokladPlanDlg(
        parentContent: GContent,
        opt: {
            /** ixs_pla */
            ixs_pla: string | null,
            /** ixs_tip */
            ixs_tip: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailAdeInstitutPredpokladPlan', { Id: "SeznamAdeInstitutPredpokladPlan", gridRemoteControl: gridRemoteControl }]

    const options = {
        Id: "AdmAdeInstitutPredpokladPlan",
        ixs_pla: opt ? opt.ixs_pla : undefined,
        ixs_tip: opt ? opt.ixs_tip : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdeInstitutPredpokladPlan
    export function SeznamAdeInstitutPredpokladPlanDlg(
        parentContent: GContent,
        opt: {
            /** ixs_pla */
            ixs_pla: string | null,
            /** ixs_tip */
            ixs_tip: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamAdeInstitutPredpokladPlan', { Id: "SeznamAdeInstitutPredpokladPlan" }]

    const options = {
        Id: "AdmAdeInstitutPredpokladPlan",
        ixs_pla: opt ? opt.ixs_pla : undefined,
        ixs_tip: opt ? opt.ixs_tip : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
